export const currencyFormatter = new Intl.NumberFormat('en-US', {minimumFractionDigits: 0, maximumFractionDigits: 0});

export const currencyFormatterDecimal = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
});

/**
 * General number formatter with US standard comma formatting
 * @param {number} minFractionDigits - Minimum decimal places (default: 0)
 * @param {number} maxFractionDigits - Maximum decimal places (default: 2)
 * @returns {Intl.NumberFormat} Formatter instance
 */
export const numberFormatter = (minFractionDigits = 0, maxFractionDigits = 2) => {
    return new Intl.NumberFormat('en-US', {
        minimumFractionDigits: minFractionDigits,
        maximumFractionDigits: maxFractionDigits
    });
};

export const preferredCountries = ["971", "966", "974", "965","968","973"];

export const cleanName = (name = "") => {
    return name
        .toLowerCase() // Convert the entire string to lowercase
        .replace(/[_-]+/g, " ") // Replace underscores and dashes with spaces
        .replace(/\b\w/g, (l) => l.toUpperCase()); // Capitalize each word
};

export const booleanFormatter = (value, [trueLabel = "True", falseLabel = "False"] = []) => {
    // Check if the value is 0 or falsy, return the false label
    if (!value || value === 0) {
        return falseLabel;
    }
    // For truthy values, return the true label
    return trueLabel;
};

export const dateFormatter = (date, options = {}) => {

    if (!date) {
        return "-";
    }

    const defaultOptions = {
        year: "numeric",
        month: "short",
        day: "numeric",
    };

    return new Date(date).toLocaleDateString("en-US", {...defaultOptions, ...options});
}

export const timeFormatter = (time) => {
    if (!time) {
        return "-";
    }
    const date = new Date(`1970-01-01T${time}`);
    return date.toLocaleTimeString([], {hour: '2-digit', minute: '2-digit', hour12: true});
};

